import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/twitter.svg'


const _withScopeId = n => (_pushScopeId("data-v-523a9ca3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex items-center justify-center w-full h-full" }
const _hoisted_2 = { class: "w-11/12 pt-16 bg-white sm:w-96 max-w-96" }
const _hoisted_3 = { class: "my-5" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "w-6 filter invert",
  src: _imports_0
}, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "my-4 seperator text-secondary" }, "or", -1))
const _hoisted_7 = ["onSubmit"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Not a member yet? ")
const _hoisted_10 = ["onClick"]

import Button from '@/components/UI/Button.vue';
import { useRouter } from 'vue-router';
import { useUserStore } from '@/store/users';
import { Ref, inject, onErrorCaptured, onMounted, ref, toRefs } from 'vue';
import FloatingHeaderTextField from '@/components/Inputs/FloatingHeaderTextField.vue';
import Logo from '@/components/UI/Logo.vue';
import { remove } from 'tiny-cookie';
import { AlertModal } from '@/typings/modal';


export default /*#__PURE__*/_defineComponent({
  props: {
    nextUrl: null
  },
  setup(__props: any) {

const props = __props as {
  nextUrl?: string;
}

const alertModal = inject<Ref<AlertModal>>('alertModal');

onMounted(() => {
  remove('twitter-warning');
});



const router = useRouter();

const user = ref({
  email: '',
  password: '',
});

const userStore = useUserStore();

if (userStore.user) {
  router.push({ name: 'Scorecards' });
}

const { validationError } = toRefs(userStore);

async function login() {
  const success = await userStore.login(user.value.email, user.value.password);
  if (success) {
    if (props.nextUrl) {
      router.push(props.nextUrl);
    } else {
      router.push('scorecards');
    }
  }
}

async function forgottenPassword() {
  router.push({
    name: 'ForgottenPassword',
    params: { email: user.value.email },
  });
}

async function register() {
  router.push({
    name: 'Register',
    params: { email: user.value.email, nextUrl: props.nextUrl },
  });
}

async function twitterLogin() {
  if (alertModal?.value) {
    alertModal.value.show(
      'Twitter Login Is Deprecated',
      "Due to changes with Twitter's login service, we have discontinued its support. To continue playing, please contact us at feedback@prowrestlingscorecards.com with your Twitter handle and email address you wish to be associated with your account."
    );
  }
}

onErrorCaptured((err) => {
  console.error(err);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Logo),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", { class: "flex items-center justify-center space-x-4" }, [
          _createElementVNode("div", {
            class: "flex items-center justify-center w-20 h-12 border rounded cursor-pointer bg-twitter",
            onClick: twitterLogin
          }, _hoisted_5)
        ]),
        _hoisted_6,
        _createElementVNode("form", {
          class: "px-4 space-y-6 text-center",
          onSubmit: _withModifiers(login, ["prevent"])
        }, [
          _createVNode(FloatingHeaderTextField, {
            title: "Email",
            modelValue: user.value.email,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((user.value.email) = $event))
          }, null, 8, ["modelValue"]),
          _createVNode(FloatingHeaderTextField, {
            title: "Password",
            modelValue: user.value.password,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((user.value.password) = $event)),
            type: "password"
          }, null, 8, ["modelValue"]),
          _withDirectives(_createElementVNode("div", { class: "text-red-600" }, _toDisplayString(_unref(validationError)), 513), [
            [_vShow, _unref(validationError)]
          ]),
          _createVNode(Button, {
            label: "Login",
            type: "primary",
            class: "w-full py-3 font-bold rounded text-md"
          }),
          _createElementVNode("div", null, [
            _createElementVNode("span", {
              class: "font-black cursor-pointer text-primary hover:text-primary-dark",
              onClick: _withModifiers(forgottenPassword, ["prevent"])
            }, " Forgot password? ", 8, _hoisted_8)
          ]),
          _createElementVNode("div", null, [
            _hoisted_9,
            _createElementVNode("span", {
              class: "font-black cursor-pointer text-primary hover:text-primary-dark",
              onClick: _withModifiers(register, ["prevent"])
            }, " Register now ", 8, _hoisted_10)
          ])
        ], 40, _hoisted_7)
      ])
    ])
  ]))
}
}

})